<template lang="html">
    <div>
      <Button
      type="primary"
      style="float: right"
      @click.native="refreshUsers()">
      <Icon type="refresh"/><!--refreshAssociates-->
       </Button>

       <Button
         @click.native="addUser()"
        type="primary"
        style="float: right; margin-right: 5px"
        :disabled="false">
         <Icon type="plus-round"/> <!--newform-->
          Aggiungi
        </Button>
        &nbsp;
        <Input style="width: 15rem" v-model="filters.search" autofocus type="text" placeholder="Ricerca..."/>
      <div  style="margin: 1em 0">
      <div class="ivu-table spaced utenti-table" style="margin: 1em 0; ;" :loading="loading">
        <table>
          <thead>
            <tr>
              <th v-for="col in cols" :key="col.id"
              @click="col.sortable && toggleSort(col)" :class="{sortable: col.sortable}" :col="col.key">
                {{ col.title }}
                <Icon v-if="sort_by.key == col.key" :type="'ios-arrow-'+(sort_by.asc?'down':'up')"/>
              </th>
              <!--
               <th>
                 ID
                </th>
                <th>
                 Username
                </th>
                <th>
                 Superadmin?
                </th>
                <th>
                 Email
                </th>
                <th v-if="$store.config.NAME=='Edesoft'  || $store.config.IS_LOCAL">
                 Status
                </th>
                <th>
                 Centri
                </th>
                <th>
                 Azioni
                </th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                {{user.id}}
              </td>
              <td>
                {{user.name}}
              </td>
              <td>
                {{user.is_admin}}
              </td>
              <td>
                {{user.email}}
              </td>
              <td v-if="$store.config.NAME=='Edesoft'  || $store.config.IS_LOCAL">
                <Button type="info" v-if="user.expiration_date==null">
                    <b>Data scadenza</br>non impostata</b>
                </Button>
                <Button type="primary" v-if="user.status==true && user.expiration_date!=null">
                    <b>{{user.expiration_date}}</b>
                </Button>
                <Button type="error" v-if="user.status==false">
                    <b>{{user.expiration_date}}</b>
                </Button>
              </td>
              <td>
                 <div class="ivu-table spaced utenti-table" style="margin: 1em 0; ;" >
        <table>
          <thead>
            <tr>
               <th style="width:50%">
                 Ruolo
                </th>
                <th style="width:50%">
                 Compagnia
                </th>
            </tr>
          </thead>
          <tbody >
              <tr v-for="role in user.roles">
              <td>
                {{role.role}}
              </td>
              <td>
                {{role.company.name}}
              </td>
              </tr>
            
          </tbody>
          </table>
          </div>
              </td>
              <td>
                <div class="azioni-utente">
                  <Button type="primary" size="small" @click="showUser(user)">
                    <Icon type="ios-eye"/>
                  </Button>
                  <Button type="primary" size="small" @click="editUser(user)">
                    <Icon type="edit"/>
                  </Button>
                  <Button type="error" size="small" @click="delUser(user)">
                    <Icon type="trash-a"/>
                  </Button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Modal
        :mask-closable="false"
        :closable="false"
        :transfer="true"
        v-model="show_form"
        class-name="large"
        :title="(form && form.id ? 'Modifica' : 'Nuovo') + ' Utente'">
        <UtenteForm ref="user_form" v-if="form" :form="form" />
            <div slot="footer">
            </div>
            
      </Modal>
      <Modal v-model="show_details_modal">
      <div v-if="show_details">
        Username: <b>{{ show_details.name || '-' }}</b><br>
        Privilegi Admin: <b>{{ show_details.is_admin || '-' }}</b><br>
        Email: <b>{{ show_details.email || '-' }}</b><br>
        Attivo fino al: <Button type="info" v-if="show_details.expiration_date==null">
                    <b>Data scadenza non impostata</b>
                </Button>
                <Button type="primary" v-if="show_details.status==true && show_details.expiration_date!=null">
                    <b>{{show_details.expiration_date}}</b>
                </Button>
                <Button type="error" v-if="show_details.status==false">
                    <b>{{show_details.expiration_date}}</b>
                </Button>
        <br>
        <br>
        <div class="ivu-table spaced utenti-table" style="margin: 1em 0; ;" >
        <table>
          <thead>
            <tr>
               <th>
                 Ruolo
                </th>
                <th>
                 Compagnia
                </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user_role in user_roles">
              <td>
                {{user_role.role}}
              </td>
              <td>
                {{user_role.name}}
              </td>
            </tr>
          </tbody>
          </table>
          </div>
        </div>
      <div slot="footer">
        <Button type="error" @click.native="closeDetails()">
          Chiudi
        </Button>
      </div>
    </Modal>
      </div>
    </div>
    
</template>

<script>

import collect from 'collect.js'
import UtenteForm from './utente-form'

export default 
{
   name: 'utenti-list',
  
  components:
  {
    UtenteForm,
  },

  data()
  {
    return{
      show_details_modal: false,
      show_details: true,
      console,
      loading: true,
      form: null,
      show_form: false,
      users: {},
      user_roles: {},
      fast_roles: Array(),
      filters: {
        search: '',
      },
      sort_by: {
        key: 'number',
        asc: true,
      },
    }
  },

  mounted() {
    this.refreshUsers()
  },

  methods:
  {
    toggleSort (col) {
      if (this.sort_by.key == col.key) {
        this.sort_by.asc = !this.sort_by.asc
      } else {
        this.sort_by = {
          key: col.key,
          asc: true,
        }
      }
    },
    addUser () {
      var new_user = {}
      new_user.name = prompt('Nome del nuovo utente')
      if (!new_user.name) return window.alert("Campo Utente vuoto");
      new_user.email = prompt('Indirizzo email del nuovo utente')
      if (!new_user.email) return window.alert("Campo Email vuoto");
      new_user.is_admin = prompt('Superadmin? (1 = Vero | 0 = Falso)')
      if (!new_user.is_admin || (new_user.is_admin != 0 && new_user.is_admin != 1)) return window.alert("Campo Superadmin errato");

      this.$http.post('users', new_user).then(res => {
        this.refreshUsers()
      })
    },
    getCDate(pY,pM,pD)
    {
      let current = new Date();
      current.setDate(current.getDate()+pD)
      current.setMonth(current.getMonth()+pM)
      current.setFullYear(current.getFullYear() + pY)
      let cDate = (current.getFullYear() + '-' + (current.getMonth()+1) + '-' + (current.getDate()));
      return cDate;
    },
    refreshUsers() 
    {
      this.loading = true
      var params = Object.assign(this.filters)
      this.$http.get('users',  { params }).then(res => {
        this.users = res.data
      }).finally(() => {
        console.log(this.users)
        let i
        for ( i = 0; i < this.users.length; i++) {
            let flagM = false
            if(this.users[i].expiration_date==null)
            {
                  flagM = true
                  this.users[i].status=true
            }
            if(Date.parse(this.users[i].expiration_date) < Date.parse(this.getCDate(0,0,0)))
            {
                  flagM = true
                  this.users[i].status=false
            }
            if(Date.parse(this.users[i].expiration_date) >= Date.parse(this.getCDate(0,0,0)))
            {
                  flagM = true
                  this.users[i].status=true
            }
            if(flagM)
            {
              this.$http.post('users', this.users[i])
            }
         }
        this.loading = false
      })
    },
    showUser(a)
    {
      this.getUserRoles(a.id)
      this.show_details = a
      this.show_details_modal = true
    },
    editUser(a)
    {
      this.form=null
      this.show_form=false
      this.show_form = !!(this.form = _.clone(a))
    },
    getUserRoles(id)
    {
        //this.loading = true
        this.$http.get('roles/'+id).then(res => {
        this.user_roles = res.data
        //console.log(this.user_roles)
      })
    },
    getFastUserRoles(id)
    {
        this.$http.get('roles/'+id).then(res => {
         this.fast_roles.push(res.data)
      })
    },
    closeDetails()
    {
      this.show_details_modal=false
      this.user_roles = null
    },
    closeEdit()
    {
      this.show_form=false
      this.form=null
    },
    delUser(a) {
        confirm('Sicuri?') && this.$http.delete('users/'+a.id).then(() => this.refreshUsers())
    },
    post(data) {
      
      if(data.expiration_date!=null){
        if(data.expiration_date.length!=0 )
        {
          var intDate = Date.parse(data.expiration_date)
          intDate = intDate + ( 24 * 60 * 60 * 1000)
          var new_Date = new Date()
          new_Date.setTime(intDate)
          data.expiration_date = new_Date
        }
      }
      
      
      this.$http.post('users', data).then(res => {
        this.show_form = false
        this.refreshUsers()
      })
    },
  },
  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshUsers()
      }, 300)
    },
  },
  computed:{
    cols () {
      var cols = []
      cols.push({
        title: 'ID',
        key: 'number',
        width: 100,
        sortable: true,
        order_fn: ass => ass.number*1,
        // fixed: 'left',
      })
      cols.push({
        title: 'Username',
        key: 'name',
        sortable: true,
        // fixed: 'left',
      })
      cols.push({
        title: 'Superadmin?',
        key: 'is_admin',
        sortable: true,
        // fixed: 'left',
      })
      cols.push({
        title: 'Email',
        key: 'email',
        sortable: true, 
      })
      if (true) cols.push({
        title: 'Status',
        key: 'status',
        sortable: false,
      })
      cols.push({
        title: 'Centri',
        key: 'assoiations',
        sortable: false,
      })
      let acts = null
      cols.push({
        width: 210,
        title: 'Azioni',
        key: 'action',
        align: 'center',
      })

      return cols
    }
  }
}
</script>

<style lang="scss">
.nolabelmargin {
  .ivu-form-item-content {
    margin-left: 0!important;
  }
}
.utenti-table {
  th.sortable {
    cursor: pointer;
  }
  &[loading] {
    opacity: .4;
  }
  .azioni-utente {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    button {
      margin-right: 4px;
      border-radius: 6px;
    }
  }

  th[col=action] {
    width: 0;
  }
}
</style>

